import { Observable } from 'rxjs';
import _ from 'lodash';

import BudgetAllocationsApi from 'entities/budgetAllocation/api';
import DonationsApi from 'entities/donation/api';
import { selectDonationById } from 'entities/donation/selectors';
import { selectDonationMatchingRules } from 'entities/donationMatchingRule/selectors';
import DonationMatchingRulesApi from 'entities/donationMatchingRule/api';
import { selectUser } from 'entities/user/selectors';
import { Privileges } from 'utils/privileges';

import { initSuccessAction, initFailedAction } from './actions';
import { INIT } from './constants';

const init = (action$, store) =>
  action$.ofType(INIT).exhaustMap((payload) => {
    const actions = [];
    const state = store.getState();
    const user = selectUser(state);

    const donation = selectDonationById(state, payload.id);
    if (user?.hasPrivilege(Privileges.DONATION_VIEW) && !donation) {
      actions.push(DonationsApi.fetchById(payload.id));
    }

    const donationMatchingRules = selectDonationMatchingRules(state);
    if (user?.hasPrivilege(Privileges.DONATION_MANAGE_RULES) && donationMatchingRules.size === 0) {
      actions.push(DonationMatchingRulesApi.fetchAll());
    }

    if (user?.hasPrivilege(Privileges.DONATION_MANAGE_RULES)) {
      actions.push(BudgetAllocationsApi.fetchAll());
    }

    if (actions.length === 0) {
      return Observable.of(initSuccessAction());
    }

    return Observable.combineLatest(actions)
      .mergeMap((resultingActions) => [..._.flatten(resultingActions), initSuccessAction()])
      .catch((e) => Observable.of(initFailedAction(e)));
  });

export default [init];
